<template>
  <div class="section address-reading">
    <div :class="loading ? 'loading' : ''">
      <div v-if="loading" class="spinner">
        <div class="double-bounce1"></div>
        <div class="double-bounce2"></div>
      </div>
      <div v-if="loading || schoolDistricts"
        class="current-address current-address--schoolDistrict">
        <div v-if="loading">
          <h3 class="grade-range">&nbsp;</h3>
          &nbsp;<br>&nbsp;
        </div>
        <div v-else>
          <div v-for="district in schoolDistricts" :key="district.id">
            <h3 class="grade-range">{{district.lowGrade}} to {{district.highGrade}}</h3>
            {{district.name}}
          </div>
        </div>
      </div>
      <div v-else>
        <p>What is my address works by using the GPS from your device and looking up online what the address at that location is. Your location could not be determined, or you did not accept the request to use your location, so you are seeing this message instead.</p>
      </div>
      <table class="address-details">
        <tr v-if="loading || (address && address.locality)">
          <th>{{ labels.locality }}</th>
          <td>{{ address ? address.locality : ' ' }}</td>
        </tr>
        <tr v-if="loading || (address && address.adminDistrict2)">
          <th>{{ labels.adminDistrict2 }}</th>
          <td>{{ address ? address.adminDistrict2 : ' ' }}</td>
        </tr>
        <tr v-if="loading || (address && address.adminDistrict)">
          <th>{{ labels.adminDistrict }}</th>
          <td>{{ address ? address.adminDistrict : ' ' }}</td>
        </tr>
        <tr v-if="loading || (township && township.townshipName && !township.townshipName.includes('CCD'))">
          <th>Township</th>
          <td>{{ township ? township.townshipName : ' ' }}</td>
        </tr>
        <tr v-if="loading || (address && address.countryRegion)">
          <th>{{ labels.countryRegion }}</th>
          <td>{{ address ? address.countryRegion : ' ' }}</td>
        </tr>
      </table>
    </div>
    <SchoolDistrictDetails :districts="schoolDistricts" />
  </div>
</template>
<script>
import SchoolDistrictDetails from '@/components/SchoolDistrictDetails.vue';

export default {
  components: { SchoolDistrictDetails },
  props: ['address', 'township', 'schoolDistricts', 'loading'],
  computed: {
    labels() {
      if (this.address && this.address.countryRegion && this.address.countryRegion === 'United States') {
        return {
          countryRegion: 'Country',
          postalCode: 'ZIP Code',
          adminDistrict: 'State',
          adminDistrict2: 'County',
          locality: 'City',
        };
      }
      return {
        countryRegion: 'Country/Region',
        postalCode: 'Postal Code',
        adminDistrict: 'State/Provence',
        adminDistrict2: 'City/Region',
        locality: 'City',
      };
    },
  },
};
</script>
